














 

















const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "meetingId",
    "variableName": "meetingId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StandardMutationError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ErrorPayload",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseType",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stages",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v10/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v12 = [
  (v4/*: any*/),
  (v8/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorStageId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigable",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigableByFacilitator",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readyCount",
  "storageKey": null
},
v19 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeetingStage"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupColor",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ReflectPrompt",
  "kind": "LinkedField",
  "name": "prompt",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerCreator",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reflectionGroupId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Reactji",
  "kind": "LinkedField",
  "name": "reactjis",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isViewerReactji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "users",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v30 = [
  (v6/*: any*/),
  (v4/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEditing",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDropping",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "RemoteReflectionDrag",
  "kind": "LinkedField",
  "name": "remoteDrag",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dragUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dragUserName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSpotlight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientX",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientY",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetOffsetX",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetOffsetY",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerDragging",
  "storageKey": null
},
v36 = {
  "kind": "ClientExtension",
  "selections": [
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/)
  ]
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaintextContent",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerVoteCount",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleIsUserDefined",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExpanded",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voteCount",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discussionId",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "focusedPromptId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "editorIds",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorUserId",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v49 = [
  (v48/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesRemaining",
  "storageKey": null
},
v52 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "groupTitle",
    "storageKey": null
  }
],
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "facilitator",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v54 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v4/*: any*/)
],
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMember",
  "plural": false,
  "selections": (v54/*: any*/),
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerReady",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestedTimeLimit",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledEndTime",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "filters": null,
  "handle": "localTime",
  "key": "",
  "kind": "ScalarHandle",
  "name": "scheduledEndTime"
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestedEndTime",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAsync",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeRemaining",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamMemberId",
  "storageKey": null
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    (v55/*: any*/)
  ],
  "type": "NewMeetingTeamMemberStage",
  "abstractKey": "__isNewMeetingTeamMemberStage"
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        (v48/*: any*/),
        (v6/*: any*/),
        (v5/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "CheckInStage",
  "abstractKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerVote",
  "storageKey": null
},
v67 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "votedUsers",
  "plural": true,
  "selections": (v67/*: any*/),
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "labels",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votedUserIds",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRevealed",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localScheduledEndTime",
  "storageKey": null
},
v74 = {
  "kind": "ClientExtension",
  "selections": [
    (v73/*: any*/)
  ]
},
v75 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeetingPhase"
},
v76 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkInQuestion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingGreeting",
      "kind": "LinkedField",
      "name": "checkInGreeting",
      "plural": false,
      "selections": [
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CheckInPhase",
  "abstractKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v78 = [
  (v77/*: any*/),
  (v4/*: any*/)
],
v79 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TeamMemberIntegrationAuthWebhook",
    "kind": "LinkedField",
    "name": "auth",
    "plural": false,
    "selections": (v78/*: any*/),
    "storageKey": null
  }
],
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMemberIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MattermostIntegration",
      "kind": "LinkedField",
      "name": "mattermost",
      "plural": false,
      "selections": (v79/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MSTeamsIntegration",
      "kind": "LinkedField",
      "name": "msTeams",
      "plural": false,
      "selections": (v79/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SlackIntegration",
      "kind": "LinkedField",
      "name": "slack",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultTeamChannelId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SlackNotification",
          "kind": "LinkedField",
          "name": "notifications",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "channelId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "event",
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "viewerMeetingMember",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMembers",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tierLimitExceededAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v83/*: any*/)
  ],
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v86 = [
  (v4/*: any*/)
],
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "OrganizationUser",
  "kind": "LinkedField",
  "name": "viewerOrganizationUser",
  "plural": false,
  "selections": (v86/*: any*/),
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v87/*: any*/)
  ],
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSidebar",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRightDrawerOpen",
  "storageKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        (v90/*: any*/)
      ]
    }
  ],
  "type": "PokerMeeting",
  "abstractKey": null
},
v92 = {
  "kind": "InlineFragment",
  "selections": [
    (v63/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": [
        (v48/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UpdatesStage",
  "abstractKey": null
},
v93 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AgendaItem",
      "kind": "LinkedField",
      "name": "agendaItem",
      "plural": false,
      "selections": [
        (v27/*: any*/),
        (v55/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AgendaItemsStage",
  "abstractKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMember",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v96 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHTML",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueKey",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectKey",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "_xGitHubRepository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v103/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHtml",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iid",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webUrl",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamProject",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v114 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endCursor",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasNextPage",
    "storageKey": null
  }
],
v115 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v8/*: any*/),
    (v87/*: any*/)
  ],
  "storageKey": null
},
v117 = {
  "kind": "InlineFragment",
  "selections": [
    (v70/*: any*/),
    (v72/*: any*/)
  ],
  "type": "TeamHealthStage",
  "abstractKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "localPhase",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        (v10/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v64/*: any*/),
        (v19/*: any*/),
        (v18/*: any*/),
        (v56/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    (v75/*: any*/),
    (v9/*: any*/),
    (v76/*: any*/)
  ],
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskId",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v121 = {
  "alias": "jiraUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v122 = {
  "alias": "ghUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationHash",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVoting",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateScaleRef",
  "kind": "LinkedField",
  "name": "scale",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TemplateScaleValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        (v124/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryString",
  "storageKey": null
},
v128 = [
  (v127/*: any*/),
  (v4/*: any*/)
],
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMemberIntegrationAuthOAuth2",
  "kind": "LinkedField",
  "name": "auth",
  "plural": false,
  "selections": (v86/*: any*/),
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJQL",
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectKeyFilters",
  "storageKey": null
},
v133 = [
  (v4/*: any*/),
  (v127/*: any*/),
  (v131/*: any*/),
  (v132/*: any*/)
],
v134 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenantId",
    "storageKey": null
  },
  (v129/*: any*/)
],
v135 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSpectating",
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "meetingMembers",
  "plural": true,
  "selections": [
    (v48/*: any*/),
    (v55/*: any*/)
  ],
  "storageKey": null
},
v137 = [
  (v99/*: any*/),
  (v98/*: any*/),
  (v97/*: any*/),
  (v121/*: any*/)
],
v138 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localStageId",
  "storageKey": null
},
v139 = [
  {
    "kind": "Literal",
    "name": "maxRepositories",
    "value": 100
  }
],
v140 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v141 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "occurredAt",
  "storageKey": null
},
v142 = {
  "alias": null,
  "args": null,
  "concreteType": "_xGitHubRepository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v103/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JoinMeetingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "joinMeeting",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MeetingSelector_meeting"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MeetingCard_meeting"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "JoinMeetingSuccess",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JoinMeetingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "joinMeeting",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isNewMeeting"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingType",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "meetingMembers",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastSeenAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastSeenAtURLs",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v9/*: any*/),
                              (v19/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RetroReflectionGroup",
                                    "kind": "LinkedField",
                                    "name": "reflectionGroup",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RetroReflection",
                                        "kind": "LinkedField",
                                        "name": "reflections",
                                        "plural": true,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v23/*: any*/),
                                          (v4/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v29/*: any*/),
                                          (v31/*: any*/),
                                          (v36/*: any*/),
                                          (v37/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v26/*: any*/),
                                      (v29/*: any*/),
                                      (v40/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          (v41/*: any*/)
                                        ]
                                      },
                                      (v42/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v43/*: any*/)
                                ],
                                "type": "RetroDiscussStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RetroDiscussStage",
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RetroReflectionGroup",
                                    "kind": "LinkedField",
                                    "name": "reflectionGroup",
                                    "plural": false,
                                    "selections": [
                                      (v38/*: any*/),
                                      (v42/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "DiscussPhase",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReflectPrompt",
                                "kind": "LinkedField",
                                "name": "reflectPrompts",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  (v45/*: any*/),
                                  (v21/*: any*/),
                                  (v20/*: any*/),
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      (v46/*: any*/)
                                    ]
                                  },
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ReflectPhase",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetrospectiveMeetingMember",
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": (v49/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "disableAnonymity",
                        "storageKey": null
                      },
                      (v50/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetrospectiveMeetingMember",
                        "kind": "LinkedField",
                        "name": "viewerMeetingMember",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v30/*: any*/),
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v51/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetroReflectionGroup",
                        "kind": "LinkedField",
                        "name": "reflectionGroups",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetroReflection",
                            "kind": "LinkedField",
                            "name": "reflections",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v31/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v26/*: any*/),
                          (v29/*: any*/),
                          (v40/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subColumnIdx",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxVotesPerGroup",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "meetingNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutogroupReflectionGroup",
                        "kind": "LinkedField",
                        "name": "autogroupReflectionGroups",
                        "plural": true,
                        "selections": (v52/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutogroupReflectionGroup",
                        "kind": "LinkedField",
                        "name": "resetReflectionGroups",
                        "plural": true,
                        "selections": (v52/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationFeatureFlags",
                            "kind": "LinkedField",
                            "name": "featureFlags",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "suggestGroups",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "zoomTranscription",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrgUserCount",
                            "kind": "LinkedField",
                            "name": "orgUserCount",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "activeUserCount",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalVotes",
                        "storageKey": null
                      },
                      (v51/*: any*/),
                      (v53/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showConversionModal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "videoMeetingURL",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TranscriptBlock",
                        "kind": "LinkedField",
                        "name": "transcription",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "speaker",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "words",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "meetingMembers",
                            "plural": true,
                            "selections": [
                              (v55/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v66/*: any*/),
                                      (v68/*: any*/),
                                      (v20/*: any*/),
                                      (v69/*: any*/),
                                      (v70/*: any*/),
                                      (v71/*: any*/),
                                      (v72/*: any*/)
                                    ],
                                    "type": "TeamHealthStage",
                                    "abstractKey": null
                                  },
                                  (v74/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v75/*: any*/),
                              (v76/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "facilitator",
                            "plural": false,
                            "selections": [
                              (v50/*: any*/),
                              (v80/*: any*/),
                              (v5/*: any*/),
                              (v81/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v82/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v88/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localStage",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v19/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v18/*: any*/),
                                  (v56/*: any*/),
                                  (v9/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v73/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v70/*: any*/),
                                      (v72/*: any*/),
                                      (v66/*: any*/),
                                      (v68/*: any*/),
                                      (v20/*: any*/),
                                      (v69/*: any*/),
                                      (v71/*: any*/)
                                    ],
                                    "type": "TeamHealthStage",
                                    "abstractKey": null
                                  },
                                  (v65/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localPhase",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "stages",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v19/*: any*/),
                                      (v4/*: any*/),
                                      (v10/*: any*/),
                                      (v18/*: any*/),
                                      (v56/*: any*/),
                                      (v9/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v64/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  (v9/*: any*/),
                                  (v75/*: any*/),
                                  (v76/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v89/*: any*/)
                            ]
                          },
                          (v91/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localStage",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v19/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RetroReflectionGroup",
                                    "kind": "LinkedField",
                                    "name": "reflectionGroup",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RetroReflection",
                                        "kind": "LinkedField",
                                        "name": "reflections",
                                        "plural": true,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v23/*: any*/),
                                          (v4/*: any*/),
                                          (v32/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v29/*: any*/),
                                          (v31/*: any*/),
                                          (v33/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          (v37/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v26/*: any*/),
                                      (v29/*: any*/),
                                      (v40/*: any*/),
                                      (v41/*: any*/),
                                      (v42/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v43/*: any*/)
                                ],
                                "type": "RetroDiscussStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v89/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localPhase",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v9/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v44/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReflectPrompt",
                                    "kind": "LinkedField",
                                    "name": "reflectPrompts",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v21/*: any*/),
                                      (v20/*: any*/),
                                      (v29/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ReflectPhase",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetroReflectionGroup",
                            "kind": "LinkedField",
                            "name": "spotlightGroup",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RetroReflection",
                                "kind": "LinkedField",
                                "name": "reflections",
                                "plural": true,
                                "selections": [
                                  (v35/*: any*/),
                                  (v4/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v32/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v31/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v37/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v38/*: any*/),
                              (v39/*: any*/),
                              (v26/*: any*/),
                              (v29/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "spotlightSearchQuery",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "spotlightReflectionId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isViewerDragInProgress",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showTranscription",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "RetrospectiveMeeting",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v92/*: any*/),
                              (v93/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v75/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaItemsStage",
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaItem",
                                    "kind": "LinkedField",
                                    "name": "agendaItem",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v27/*: any*/),
                                      (v94/*: any*/),
                                      (v95/*: any*/),
                                      (v29/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AgendaItemsPhase",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgendaItem",
                            "kind": "LinkedField",
                            "name": "agendaItems",
                            "plural": true,
                            "selections": [
                              (v29/*: any*/),
                              (v4/*: any*/),
                              (v27/*: any*/),
                              (v94/*: any*/),
                              (v95/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v96/*: any*/),
                            "concreteType": "TaskConnection",
                            "kind": "LinkedField",
                            "name": "tasks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Task",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v3/*: any*/),
                                      (v29/*: any*/),
                                      (v27/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "createdBy",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "createdByUser",
                                        "plural": false,
                                        "selections": (v30/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "integration",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v4/*: any*/),
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isTaskIntegration"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v97/*: any*/),
                                              (v98/*: any*/),
                                              (v99/*: any*/),
                                              (v100/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "cloudName",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "JiraIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v101/*: any*/),
                                              (v38/*: any*/),
                                              (v102/*: any*/),
                                              (v104/*: any*/)
                                            ],
                                            "type": "_xGitHubIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v97/*: any*/),
                                              (v98/*: any*/),
                                              (v99/*: any*/),
                                              (v100/*: any*/),
                                              (v105/*: any*/)
                                            ],
                                            "type": "JiraServerIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v106/*: any*/),
                                              (v38/*: any*/),
                                              (v107/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "webPath",
                                                "storageKey": null
                                              },
                                              (v108/*: any*/)
                                            ],
                                            "type": "_xGitLabIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v97/*: any*/),
                                              (v38/*: any*/),
                                              (v109/*: any*/),
                                              (v110/*: any*/),
                                              (v105/*: any*/)
                                            ],
                                            "type": "AzureDevOpsWorkItem",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "status",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskEditorDetails",
                                        "kind": "LinkedField",
                                        "name": "editors",
                                        "plural": true,
                                        "selections": [
                                          (v48/*: any*/),
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "tags",
                                        "storageKey": null
                                      },
                                      (v13/*: any*/),
                                      (v48/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v1/*: any*/),
                                        "kind": "ScalarField",
                                        "name": "isHighlighted",
                                        "storageKey": null
                                      },
                                      (v111/*: any*/),
                                      (v112/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dueDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v54/*: any*/),
                                        "storageKey": null
                                      },
                                      (v50/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "error",
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v113/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfoDateCursor",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": (v114/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": "tasks(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": (v96/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "TeamColumnsContainer_tasks",
                            "kind": "LinkedHandle",
                            "name": "tasks"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActionMeetingMember",
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMember",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSelf",
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v53/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v19/*: any*/),
                                  (v18/*: any*/),
                                  (v56/*: any*/),
                                  (v9/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v76/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v50/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "viewerMeetingMember",
                            "plural": false,
                            "selections": (v115/*: any*/),
                            "storageKey": null
                          },
                          (v84/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "meetingMembers",
                            "plural": true,
                            "selections": (v49/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "facilitator",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v81/*: any*/),
                              (v50/*: any*/),
                              (v80/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v85/*: any*/),
                          (v116/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localStage",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v19/*: any*/),
                                  (v10/*: any*/),
                                  (v18/*: any*/),
                                  (v56/*: any*/),
                                  (v9/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v65/*: any*/),
                                  (v117/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v118/*: any*/),
                              (v89/*: any*/)
                            ]
                          },
                          (v91/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localPhase",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v9/*: any*/),
                              (v4/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgendaItemsStage",
                                    "kind": "LinkedField",
                                    "name": "stages",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AgendaItem",
                                        "kind": "LinkedField",
                                        "name": "agendaItem",
                                        "plural": false,
                                        "selections": (v86/*: any*/),
                                        "storageKey": null
                                      },
                                      (v16/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "AgendaItemsPhase",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localStage",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v92/*: any*/),
                              (v93/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v89/*: any*/)
                        ]
                      }
                    ],
                    "type": "ActionMeeting",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v119/*: any*/),
                                  (v43/*: any*/)
                                ],
                                "type": "EstimateStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EstimateStage",
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "finalScore",
                                    "storageKey": null
                                  },
                                  (v119/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Task",
                                    "kind": "LinkedField",
                                    "name": "task",
                                    "plural": false,
                                    "selections": [
                                      (v38/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "integration",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v4/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v38/*: any*/),
                                              (v109/*: any*/),
                                              (v105/*: any*/),
                                              (v110/*: any*/),
                                              (v120/*: any*/),
                                              (v97/*: any*/)
                                            ],
                                            "type": "AzureDevOpsWorkItem",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v99/*: any*/),
                                              (v98/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "JiraIssueField",
                                                "kind": "LinkedField",
                                                "name": "possibleEstimationFields",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "fieldId",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "fieldName",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "missingEstimationFieldHint",
                                                "storageKey": null
                                              },
                                              (v97/*: any*/),
                                              (v121/*: any*/)
                                            ],
                                            "type": "JiraIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v99/*: any*/),
                                              (v98/*: any*/),
                                              {
                                                "alias": "jiraProjectId",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "projectId",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "issueType",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "possibleEstimationFieldNames",
                                                "storageKey": null
                                              },
                                              (v97/*: any*/),
                                              (v121/*: any*/)
                                            ],
                                            "type": "JiraServerIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v38/*: any*/),
                                              (v102/*: any*/),
                                              (v104/*: any*/),
                                              (v101/*: any*/),
                                              (v122/*: any*/)
                                            ],
                                            "type": "_xGitHubIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v38/*: any*/),
                                              (v107/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "projectId",
                                                "storageKey": null
                                              },
                                              (v106/*: any*/),
                                              (v108/*: any*/)
                                            ],
                                            "type": "_xGitLabIssue",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      (v123/*: any*/),
                                      (v50/*: any*/),
                                      (v37/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EstimateUserScore",
                                    "kind": "LinkedField",
                                    "name": "scores",
                                    "plural": true,
                                    "selections": [
                                      (v48/*: any*/),
                                      (v4/*: any*/),
                                      (v124/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v67/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v125/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TemplateDimensionRef",
                                    "kind": "LinkedField",
                                    "name": "dimensionRef",
                                    "plural": false,
                                    "selections": [
                                      (v126/*: any*/),
                                      (v4/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ServiceField",
                                    "kind": "LinkedField",
                                    "name": "serviceField",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v110/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v24/*: any*/),
                                  (v50/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "hoveringUsers",
                                    "plural": true,
                                    "selections": (v54/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "EstimatePhase",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v47/*: any*/),
                      (v50/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PokerMeetingMember",
                        "kind": "LinkedField",
                        "name": "viewerMeetingMember",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMember",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamMemberIntegrations",
                                "kind": "LinkedField",
                                "name": "integrations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GitHubIntegration",
                                    "kind": "LinkedField",
                                    "name": "github",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "GitHubSearchQuery",
                                        "kind": "LinkedField",
                                        "name": "githubSearchQueries",
                                        "plural": true,
                                        "selections": (v128/*: any*/),
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      (v77/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "scope",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GitLabIntegration",
                                    "kind": "LinkedField",
                                    "name": "gitlab",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IntegrationProviderOAuth2",
                                        "kind": "LinkedField",
                                        "name": "cloudProvider",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v129/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "serverBaseUrl",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "projects",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v4/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "fullPath",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "_xGitLabProject",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v130/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IntegrationProviderOAuth2",
                                        "kind": "LinkedField",
                                        "name": "sharedProviders",
                                        "plural": true,
                                        "selections": [
                                          (v129/*: any*/),
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AtlassianIntegration",
                                    "kind": "LinkedField",
                                    "name": "atlassian",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "JiraSearchQuery",
                                        "kind": "LinkedField",
                                        "name": "jiraSearchQueries",
                                        "plural": true,
                                        "selections": (v133/*: any*/),
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "JiraRemoteProject",
                                        "kind": "LinkedField",
                                        "name": "projects",
                                        "plural": true,
                                        "selections": (v12/*: any*/),
                                        "storageKey": null
                                      },
                                      (v77/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "JiraServerIntegration",
                                    "kind": "LinkedField",
                                    "name": "jiraServer",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMemberIntegrationAuthOAuth1",
                                        "kind": "LinkedField",
                                        "name": "auth",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v77/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IntegrationProviderOAuth1",
                                        "kind": "LinkedField",
                                        "name": "sharedProviders",
                                        "plural": true,
                                        "selections": (v86/*: any*/),
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "JiraServerRemoteProject",
                                        "kind": "LinkedField",
                                        "name": "projects",
                                        "plural": true,
                                        "selections": (v12/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "JiraSearchQuery",
                                        "kind": "LinkedField",
                                        "name": "searchQueries",
                                        "plural": true,
                                        "selections": (v133/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AzureDevOpsIntegration",
                                    "kind": "LinkedField",
                                    "name": "azureDevOps",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IntegrationProviderOAuth2",
                                        "kind": "LinkedField",
                                        "name": "cloudProvider",
                                        "plural": false,
                                        "selections": (v134/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IntegrationProviderOAuth2",
                                        "kind": "LinkedField",
                                        "name": "sharedProviders",
                                        "plural": true,
                                        "selections": (v134/*: any*/),
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AzureDevOpsRemoteProject",
                                        "kind": "LinkedField",
                                        "name": "projects",
                                        "plural": true,
                                        "selections": (v12/*: any*/),
                                        "storageKey": null
                                      },
                                      (v130/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserFeatureFlags",
                                "kind": "LinkedField",
                                "name": "featureFlags",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "azureDevOps",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v135/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PokerMeetingMember",
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": [
                          (v135/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "init",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": "init",
                        "args": null,
                        "filters": null,
                        "handle": "localPoker",
                        "key": "",
                        "kind": "ScalarHandle",
                        "name": "id"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v19/*: any*/),
                                  (v18/*: any*/),
                                  (v56/*: any*/),
                                  (v9/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  (v74/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v75/*: any*/),
                              (v76/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v82/*: any*/),
                          (v84/*: any*/),
                          (v136/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "facilitator",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v81/*: any*/),
                              (v4/*: any*/),
                              (v50/*: any*/),
                              (v80/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v85/*: any*/),
                          (v116/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localStage",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v19/*: any*/),
                                  (v10/*: any*/),
                                  (v18/*: any*/),
                                  (v56/*: any*/),
                                  (v9/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v73/*: any*/),
                                  (v65/*: any*/),
                                  (v117/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v118/*: any*/),
                              (v89/*: any*/)
                            ]
                          },
                          (v91/*: any*/)
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localStage",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v10/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v125/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TemplateDimensionRef",
                                    "kind": "LinkedField",
                                    "name": "dimensionRef",
                                    "plural": false,
                                    "selections": [
                                      (v126/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EstimateUserScore",
                                    "kind": "LinkedField",
                                    "name": "scores",
                                    "plural": true,
                                    "selections": [
                                      (v48/*: any*/),
                                      (v124/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v119/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Task",
                                    "kind": "LinkedField",
                                    "name": "task",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v38/*: any*/),
                                      (v37/*: any*/),
                                      (v27/*: any*/),
                                      (v50/*: any*/),
                                      (v123/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "integration",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v4/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v38/*: any*/),
                                              (v109/*: any*/),
                                              (v110/*: any*/),
                                              (v120/*: any*/),
                                              (v105/*: any*/),
                                              (v97/*: any*/)
                                            ],
                                            "type": "AzureDevOpsWorkItem",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v137/*: any*/),
                                            "type": "JiraIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v137/*: any*/),
                                            "type": "JiraServerIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v102/*: any*/),
                                              (v38/*: any*/),
                                              (v101/*: any*/),
                                              (v122/*: any*/)
                                            ],
                                            "type": "_xGitHubIssue",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v106/*: any*/),
                                              (v38/*: any*/),
                                              (v108/*: any*/),
                                              (v107/*: any*/)
                                            ],
                                            "type": "_xGitLabIssue",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "EstimateStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v89/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localPhase",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v9/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GitHubSearchQuery",
                            "kind": "LinkedField",
                            "name": "githubSearchQuery",
                            "plural": false,
                            "selections": (v128/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GitLabSearchQuery",
                            "kind": "LinkedField",
                            "name": "gitlabSearchQuery",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "selectedProjectsIds",
                                "storageKey": null
                              },
                              (v127/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraSearchQuery",
                            "kind": "LinkedField",
                            "name": "jiraSearchQuery",
                            "plural": false,
                            "selections": [
                              (v127/*: any*/),
                              (v131/*: any*/),
                              (v4/*: any*/),
                              (v132/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraSearchQuery",
                            "kind": "LinkedField",
                            "name": "jiraServerSearchQuery",
                            "plural": false,
                            "selections": [
                              (v132/*: any*/),
                              (v127/*: any*/),
                              (v131/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParabolSearchQuery",
                            "kind": "LinkedField",
                            "name": "parabolSearchQuery",
                            "plural": false,
                            "selections": [
                              (v127/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusFilters",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AzureDevOpsSearchQuery",
                            "kind": "LinkedField",
                            "name": "azureDevOpsSearchQuery",
                            "plural": false,
                            "selections": [
                              (v127/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isWIQL",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v132/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v90/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCommentUnread",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "PokerMeeting",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v50/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeeting",
                        "kind": "LinkedField",
                        "name": "prevMeeting",
                        "plural": false,
                        "selections": (v86/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeeting",
                        "kind": "LinkedField",
                        "name": "nextMeeting",
                        "plural": false,
                        "selections": (v86/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingSeries",
                        "kind": "LinkedField",
                        "name": "meetingSeries",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cancelledAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recurrenceRule",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "activeMeetings",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v111/*: any*/),
                              (v58/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v38/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v58/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v43/*: any*/),
                                  (v55/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPromptResponse",
                                    "kind": "LinkedField",
                                    "name": "response",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v27/*: any*/),
                                      (v112/*: any*/),
                                      (v111/*: any*/),
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamPromptResponseStage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPromptResponseStage",
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamMember",
                                    "kind": "LinkedField",
                                    "name": "teamMember",
                                    "plural": false,
                                    "selections": [
                                      (v48/*: any*/),
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPromptResponse",
                                    "kind": "LinkedField",
                                    "name": "response",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v37/*: any*/),
                                      (v111/*: any*/),
                                      (v48/*: any*/),
                                      (v27/*: any*/),
                                      (v112/*: any*/),
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v50/*: any*/),
                                  (v24/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "meeting",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v14/*: any*/),
                                          {
                                            "kind": "ClientExtension",
                                            "selections": [
                                              (v138/*: any*/),
                                              (v90/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "TeamPromptMeeting",
                                        "abstractKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Discussion",
                                    "kind": "LinkedField",
                                    "name": "discussion",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": (v96/*: any*/),
                                        "concreteType": "ThreadableConnection",
                                        "kind": "LinkedField",
                                        "name": "thread",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ThreadableEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "createdByUser",
                                                    "plural": false,
                                                    "selections": (v67/*: any*/),
                                                    "storageKey": null
                                                  },
                                                  (v4/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v113/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": (v114/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "thread(first:1000)"
                                      },
                                      {
                                        "alias": null,
                                        "args": (v96/*: any*/),
                                        "filters": null,
                                        "handle": "connection",
                                        "key": "DiscussionThread_thread",
                                        "kind": "LinkedHandle",
                                        "name": "thread"
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TeamPromptResponsesPhase",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeetingMember",
                        "kind": "LinkedField",
                        "name": "viewerMeetingMember",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserFeatureFlags",
                                "kind": "LinkedField",
                                "name": "featureFlags",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "gcal",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMember",
                            "plural": false,
                            "selections": [
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamMemberIntegrations",
                                "kind": "LinkedField",
                                "name": "integrations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GitHubIntegration",
                                    "kind": "LinkedField",
                                    "name": "github",
                                    "plural": false,
                                    "selections": [
                                      (v77/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "_xGitHubApi",
                                        "kind": "LinkedField",
                                        "name": "api",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "_xGitHubQuery",
                                            "kind": "LinkedField",
                                            "name": "query",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "_xGitHubUser",
                                                "kind": "LinkedField",
                                                "name": "viewer",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "_xGitHubContributionsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "contributionsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": (v139/*: any*/),
                                                        "concreteType": "_xGitHubCommitContributionsByRepository",
                                                        "kind": "LinkedField",
                                                        "name": "commitContributionsByRepository",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": [
                                                              (v140/*: any*/),
                                                              {
                                                                "kind": "Literal",
                                                                "name": "orderBy",
                                                                "value": {
                                                                  "direction": "DESC",
                                                                  "field": "OCCURRED_AT"
                                                                }
                                                              }
                                                            ],
                                                            "concreteType": "_xGitHubCreatedCommitContributionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributions",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "_xGitHubCreatedCommitContribution",
                                                                "kind": "LinkedField",
                                                                "name": "nodes",
                                                                "plural": true,
                                                                "selections": [
                                                                  (v141/*: any*/),
                                                                  (v142/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": "contributions(first:1,orderBy:{\"direction\":\"DESC\",\"field\":\"OCCURRED_AT\"})"
                                                          }
                                                        ],
                                                        "storageKey": "commitContributionsByRepository(maxRepositories:100)"
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": (v139/*: any*/),
                                                        "concreteType": "_xGitHubIssueContributionsByRepository",
                                                        "kind": "LinkedField",
                                                        "name": "issueContributionsByRepository",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": [
                                                              (v140/*: any*/),
                                                              {
                                                                "kind": "Literal",
                                                                "name": "orderBy",
                                                                "value": {
                                                                  "direction": "DESC"
                                                                }
                                                              }
                                                            ],
                                                            "concreteType": "_xGitHubCreatedIssueContributionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributions",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "_xGitHubCreatedIssueContributionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "_xGitHubCreatedIssueContribution",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v141/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": "contributions(first:1,orderBy:{\"direction\":\"DESC\"})"
                                                          },
                                                          (v142/*: any*/)
                                                        ],
                                                        "storageKey": "issueContributionsByRepository(maxRepositories:100)"
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v4/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AtlassianIntegration",
                                    "kind": "LinkedField",
                                    "name": "atlassian",
                                    "plural": false,
                                    "selections": (v78/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GcalIntegration",
                                    "kind": "LinkedField",
                                    "name": "gcal",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMemberIntegrationAuthOAuth2",
                                        "kind": "LinkedField",
                                        "name": "auth",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "providerId",
                                            "storageKey": null
                                          },
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IntegrationProviderOAuth2",
                                        "kind": "LinkedField",
                                        "name": "cloudProvider",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v129/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "meetingPrompt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationFeatureFlags",
                            "kind": "LinkedField",
                            "name": "featureFlags",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "singleColumnStandups",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v16/*: any*/),
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v82/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v83/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v136/*: any*/),
                          (v85/*: any*/),
                          (v88/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localStage",
                                "plural": false,
                                "selections": (v115/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "localPhase",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "stages",
                                    "plural": true,
                                    "selections": (v115/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v89/*: any*/)
                            ]
                          }
                        ],
                        "type": "NewMeeting",
                        "abstractKey": "__isNewMeeting"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          (v90/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showWorkSidebar",
                            "storageKey": null
                          },
                          (v138/*: any*/)
                        ]
                      }
                    ],
                    "type": "TeamPromptMeeting",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "JoinMeetingSuccess",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "m_fUw5R0ZcWWusA0NNf3DlxA",
    "metadata": {},
    "name": "JoinMeetingMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "4d6484bb1c311fc83d283dddc9610f76";

export default node;
